import services from '@/services/ascentiaServiceIndex'
import { CUSTOM_ALERTS_DERIVED_PARAMETERS_CONSTS as CA_DPC } from '../consts'

const state = {
  derivedParameterAlert: {},
  logicBuilderGuide: '',
  derivedParameters: [],
  derivedParameter: {},
  isValidParameterName: false,
}

const getters = {
  derivedParametersList(state, getters, rootState, rootGetters) {
    return state.derivedParameters.filter(item => {
      // Global Airline Filter
      if (rootGetters['globalFilter/showAllAirlines']) {
        return true
      } else {
        return (
          rootGetters['globalFilter/airlineIdsSelected'].indexOf(
            item.airlineId,
          ) > -1
        )
      }
    })
  },
}

const mutations = {
  [CA_DPC.UPDATE_DERIVED_PARAMETERS]: (state, data) =>
    (state.derivedParameters = data),
  [CA_DPC.UPDATE_DERIVED_PARAMETER_ALERT_LOGIC_BUILDER_GUIDE]: (state, data) =>
    (state.logicBuilderGuide = data),
  [CA_DPC.UPDATE_DERIVED_PARAMETER_VALIDATOR]: (state, data) =>
    (state.isValidParameterName = data),
  [CA_DPC.APPEND_CUSTOM_PARAMETER]: (state, data) =>
    state.derivedParameters.push(data),
  [CA_DPC.UPDATE_DERIVED_PARAMETER]: (state, data) => {
    state.derivedParameter = data
  },
  [CA_DPC.UPDATE_DERIVED_PARAMETER]: (state, data) => {
    const updatedParameter = { ...state.derivedParameter, ...data }
    state.derivedParameter = updatedParameter
    state.derivedParameters = state.derivedParameters.map(alertObj => {
      if (alertObj.baseAlertId === updatedParameter.id) {
        return {
          ...alertObj,
          ...updatedParameter,
        }
      } else {
        return alertObj
      }
    })
  },
}

const actions = {
  async [CA_DPC.GET_DERIVED_PARAMETER_ALERT_LOGIC_BUILDER_GUIDE](
    { commit },
    alertType,
  ) {
    try {
      const response = await services.blobTransfer.getData(
        'logicBuilderGuide',
        alertType,
        true,
      )
      if (response.data) {
        commit(
          CA_DPC.UPDATE_DERIVED_PARAMETER_ALERT_LOGIC_BUILDER_GUIDE,
          response.data,
        )
      }
    } catch (error) {
      console.log(
        `${CA_DPC.GET_DERIVED_PARAMETER_ALERT_LOGIC_BUILDER_GUIDE} error: ${error}`,
      )
    }
  },

  async [CA_DPC.SAVE_CUSTOM_PARAMETER]({ commit }, parameter) {
    const derivedParameter = {
      id: parameter?.id,
      name: parameter.parameterName,
      typeId: parameter.typeId,
      airlineId: parameter.airlineId,
      logicString: parameter.logicString,
      dataElementIds: parameter.dataElementIds,
      isActive: parameter.isActive,
      masterModelId: parameter.masterModelId,
    }

    let response

    try {
      response = await services.derivedParameters.saveData(
        'saveParameter',
        derivedParameter,
      )

      if (response.status === 201) {
        // if this is a new alert, push it onto the stack of custom alerts
        const parsedLocationResponse = response.headers.location.split('/')
        commit(CA_DPC.APPEND_CUSTOM_PARAMETER, response)
        commit(CA_DPC.UPDATE_DERIVED_PARAMETER, {
          id: parsedLocationResponse[parsedLocationResponse.length - 1],
        })
        // validation check is implicitly done in sucess case.

        commit(CA_DPC.UPDATE_DERIVED_PARAMETER, {
          validLogic: true,
          errorMessage: null,
          logicString: null,
        })
      } else if (response.status === 200) {
        const expressionObj = response.data.isValid
          ? { expression: response.logicString }
          : {}
        commit(CA_DPC.UPDATE_DERIVED_PARAMETER, {
          validLogic: response.data.isValid,
          errorMessage: response.data.errorMessage,
          logicString: response,
          ...expressionObj,
        })
      }
    } catch (error) {
      console.log(`${CA_DPC.SAVE_CUSTOM_PARAMETER} error: ${error}`)
    }
  },

  async [CA_DPC.GET_DERIVED_PARAMETER_VALIDATOR](
    { commit },
    derivedParameterObj,
  ) {
    const response = await services.derivedParameters.saveData(
      'parameterNameValidation',
      derivedParameterObj,
      true,
    )
    commit(CA_DPC.UPDATE_DERIVED_PARAMETER_VALIDATOR, response.data)
  },
  [CA_DPC.UPDATE_DERIVED_PARAMETER]({ commit }, parameterData) {
    commit(CA_DPC.UPDATE_DERIVED_PARAMETER, parameterData)
  },
  async [CA_DPC.GET_DERIVED_PARAMETER]({ commit }, parameterID) {
    commit(CA_DPC.UPDATE_DERIVED_PARAMETER, [])
    const response = await services.derivedParameters.getData(
      'derivedParameter',
      parameterID,
      true,
    )

    commit(CA_DPC.UPDATE_DERIVED_PARAMETER, response.data)
  },

  async [CA_DPC.GET_DERIVED_PARAMETERS_BY_AIRLINE_ID](
    // eslint-disable-next-line no-unused-vars
    { commit },
    parameterData,
    args = { refresh: true },
  ) {
    if (parameterData) {
      try {
        const response = await services.derivedParameters.getData(
          'derivedParameters',
          parameterData,
          args.refresh,
        )

        if (response.status === 200) {
          return response.data
        }

        return []
      } catch (error) {
        console.log(
          `${CA_DPC.GET_DERIVED_PARAMETERS_BY_AIRLINE_ID} error: ${error}`,
        )
      }
    } else {
      console.log(
        `${CA_DPC.GET_DERIVED_PARAMETERS_BY_AIRLINE_ID} error: No airlineId available`,
      )
    }
  },

  async [CA_DPC.GET_DERIVED_PARAMETERS](
    { commit, rootState },
    airlineId,
    args = { refresh: true },
  ) {
    try {
      commit(CA_DPC.UPDATE_DERIVED_PARAMETERS, [])
      const response = await services.derivedParameters.getData(
        'derivedParameters',
        airlineId,
        args.refresh,
      )
      const parametersWithAirlineName = response.data.map(parameterObj => {
        const airlineName = rootState.user.airlines.filter(airlineObj => {
          return airlineObj.id === parameterObj.airlineId
        })
        const masterModelName = rootState.lookups.masterModels.filter(
          mastermodelObj => {
            return mastermodelObj.masterModelId === parameterObj.masterModelId
          },
        )
        return {
          ...parameterObj,
          airline: airlineName.length ? airlineName[0].name : '',
          masterModel: masterModelName.length ? masterModelName[0].text : '',
        }
      })

      commit(CA_DPC.UPDATE_DERIVED_PARAMETERS, parametersWithAirlineName)
    } catch (error) {
      console.log(`${CA_DPC.GET_DERIVED_PARAMETERS} error: ${error}`)
    }
  },

  // eslint-disable-next-line no-empty-pattern
  async [CA_DPC.DELETE_DERIVED_PARAMETER]({}, idsToDelete) {
    try {
      return services.derivedParameters.deleteData(
        'derivedParameter',
        idsToDelete,
        true,
      )
    } catch (error) {
      console.log(`${CA_DPC.DELETE_DERIVED_PARAMETER} error: ${error}`)
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
